module.exports = __webpack_public_path__ + "img/loading_dog_05.a7ee163d.png";